import { messageRef } from './consts';

export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${messageRef} .chat-messages {
    display: flex;
    flex-direction: column;
    max-height: 600px;
    overflow-y: scroll;
  }

  .${messageRef} .chat-message-left,
  .${messageRef} .chat-message-right {
    display: flex;
    flex-shrink: 0;
  }

  .${messageRef} .chat-message-left {
    margin-right: auto;
  }

  .${messageRef} .chat-message-right {
    flex-direction: row-reverse;
    margin-left: auto;
  }
  </style>
`;
  bm.add(messageRef, {
    label: `<i class="webconnect-chat-dots"></i><div>${label}</div>`,
    category: category,
    content: `
    <div class="${messageRef}" data-gjs-type="${messageRef}" data-js="${messageRef}">
      <img src="https://drapcode-static.s3.amazonaws.com/img/chat.png" alt="Message" data-gjs-custom-name="Message Placeholder" data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false" data-gjs-selectable="false" data-gjs-highlightable="false"/>
    </div>${style}`,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
}
